import { useState } from "react";

import { DecimalInput } from "@/components/form-control/decimal-input";
import { evaluateFees, formatFeeAmount } from "../../fee-config.const";
import { CreateFeeConfigInput } from "../../fee-config.type";
import { toMinorUnit } from "../../pricing-configurator.const";

type FeeConfigPreviewProps = {
  config: CreateFeeConfigInput | null;
};

export const FeeConfigPreview = ({ config }: FeeConfigPreviewProps) => {
  const [samplePrice, setSamplePrice] = useState<number | undefined>(10);

  const breakdown = config && samplePrice !== undefined ? evaluateFees(toMinorUnit(samplePrice), config) : null;

  return (
    <div className="rounded-lg border border-border bg-muted/30 p-4 space-y-3">
      <div className="flex items-center gap-3">
        <label htmlFor="fee-preview-price" className="text-sm font-medium whitespace-nowrap">
          Prix de stationnement d'essai (€)
        </label>
        <DecimalInput id="fee-preview-price" className="w-28" value={samplePrice} onValueChange={setSamplePrice} />
      </div>

      {!breakdown ? (
        <p className="text-xs text-muted-foreground">
          {config
            ? "Saisissez un prix d'essai pour afficher l'aperçu de la commission appliquée."
            : "Complétez le formulaire pour afficher l'aperçu de la commission appliquée."}
        </p>
      ) : (
        <div className="space-y-1 text-sm">
          {config &&
            config.rules.length > 1 &&
            breakdown.perRule.map((rule) => (
              <div key={rule.ruleIndex} className="flex justify-between text-xs text-muted-foreground">
                <span>Règle {rule.ruleIndex + 1}</span>
                <span>
                  {formatFeeAmount(rule.output)} (client {formatFeeAmount(rule.customerShare)})
                </span>
              </div>
            ))}
          <div className="flex justify-between font-medium">
            <span>Commission totale</span>
            <span>{formatFeeAmount(breakdown.total)}</span>
          </div>
          <div className="flex justify-between text-muted-foreground">
            <span>Payé par le client à l'achat</span>
            <span>{formatFeeAmount(breakdown.customerShare)}</span>
          </div>
          <div className="flex justify-between text-muted-foreground">
            <span>Reversé à la ville</span>
            <span>{formatFeeAmount(breakdown.citySettlement)}</span>
          </div>
        </div>
      )}
    </div>
  );
};
